import Avatar, { AvatarI } from "shared/ui/avatar";

export type NotificationAvatarI = AvatarI;

export const NotificationAvatar = (props: NotificationAvatarI) => (
  <Avatar className="h-10 w-10" {...props} />
);
